import { Sparkles } from "lucide-react";
import { safeHtml } from "@/lib/sanitize";
import { TONE_SWATCH } from "./constants";

export default function CoverPreview({ draft }) {
  const tone = TONE_SWATCH[draft.tone || "slate"] || TONE_SWATCH.slate;
  return (
    <div
      className="min-h-[420px] bg-slate-50 px-6 py-10 flex items-center justify-center"
      data-testid="admin-cover-preview"
    >
      <div className="max-w-md text-center">
        {draft.image_url ? (
          <img
            src={draft.image_url}
            alt=""
            className="mx-auto mb-4 max-h-32 rounded-xl object-contain"
            data-testid="admin-cover-preview-image"
          />
        ) : (
          <span
            className={`inline-flex h-12 w-12 items-center justify-center rounded-2xl ${tone}`}
          >
            <Sparkles className="h-5 w-5" />
          </span>
        )}
        {draft.eyebrow ? (
          <p className="mt-4 text-xs font-medium uppercase tracking-[0.18em] text-slate-500">
            {draft.eyebrow}
          </p>
        ) : null}
        <h1
          className="mt-2 text-2xl sm:text-3xl font-medium text-slate-900 tracking-tight"
          data-testid="admin-cover-preview-title"
        >
          {draft.title || "Your title"}
        </h1>
        <div
          className="prose prose-sm mt-4 text-slate-600 mx-auto [&_a]:text-sky-700 [&_a]:underline"
          dangerouslySetInnerHTML={safeHtml(
            draft.body_html || "<p>Your body copy appears here.</p>",
          )}
          data-testid="admin-cover-preview-body"
        />
        {draft.button_label ? (
          <div className="mt-6">
            <span
              className="inline-flex rounded-xl bg-slate-900 px-4 py-2 text-sm font-medium text-white"
              data-testid="admin-cover-preview-button"
            >
              {draft.button_label}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
}
